export default {
    baseStyle: {
        shopBySeries: {
            padding: ['16px', '32px', '28px 64px'],
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            maxWidth: ['100%', '100%', '100%', '100%', '1920px'],
            margin: '0 auto',
            marginTop: '20px'
        },
        shopBySeriesInner: {
            position: 'relative'
        },
        heading: {
            fontSize: ['32px', '48px'],
            fontWeight: '800',
            margin: '0 0 32px'
        },
        viewAll: {
            display: 'block',
            textAlign: 'right',
            width: '100%'
        },
        viewAllSeries: {
            display: 'inline',
            color: '#000',
            textAlign: 'right',
            fontSize: ['16px', '16px', '20px'],
            fontWeight: '800',
            lineHeight: ['24px', '24px', '32px'],
            borderBottom: '1px solid',
            marginBottom: '32px',
            backgroundPosition: '100% center',
            backgroundRepeat: 'no-repeat',
            paddingRight: '25px'
        },
        gridView: {
            marginBottom: '16px',
            display: 'flex',
            flexWrap: 'wrap'
        },
        sbsComponent: {
            padding: '16px 12.5px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flex: ['0 0 33.3%', '0 0 25%', '0 0 16.66%'],
            maxWidth: ['33.3%', '25%', '16.66%']
        }
    },
    parts: [
        'shopBySeries',
        'shopBySeriesInner',
        'heading',
        'viewAll',
        'viewAllSeries',
        'gridView',
        'sbsComponent'
    ]
}
